export const ALLOWED_ATTACHMENT_EXTENSIONS = ['txt', 'pdf', 'csv', 'mp4', 'jpg', 'jpeg', 'png', 'bmp', 'gif', 'webp'];

export const ATTACHMENT_ACCEPT = ALLOWED_ATTACHMENT_EXTENSIONS.map((ext) => `.${ext}`).join(', ');
